/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "566")
  

// 接口文档

  
    
export interface IAPI78426ReqAppResourcePermissionObj {
  
  /** 部门ids ,String */
  deptIds?: string[];
  
  /** 用户ids ,String */
  userIds?: string[];
  
  /** 外部平台 ,String */
  platformCodeList?: string[];
  
  /** 权限类型 */
  permissionType?: string;
  
};
    
  



export interface API78426Req {
  
  /** 复制应用编码 */
  copyAppCode: string;
  /** 应用名称 */
  appName: string;
  /** 应用描述 */
  appDesc?: string;
  /** 应用资源配置 ,AppResourcePermissionReq */
  appResourcePermission?: IAPI78426ReqAppResourcePermissionObj;
};



export type API78426Res = {};


// 接口函数 78426 复制应用

export interface IUsePostAPI78426Return {
  /** 复制应用: 接口请求状态 */
  isAPI78426Loading: boolean;
  /** 复制应用: 接口请求返回数据 */
  dataAPI78426: API78426Res;
  /**  复制应用: 接口数据请求方法 */
  fetchAPI78426Data: (inputs: API78426Req, config?: YWRequestConfig) => Promise<API78426Res>;
  /** 复制应用: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI78426 = ():IUsePostAPI78426Return => {
  let isMount = true;
  const [isAPI78426Loading, setIsAPI78426Loading] = useState(false);
  const [dataAPI78426, setDataAPI78426] = useState<API78426Res>({} as API78426Res);
  const requestUrl = `${basePath}/yoaichat-admin/app/copy`;

  const fetchAPI78426Data = async (inputs: API78426Req, config?: YWRequestConfig): Promise<API78426Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API78426Req>) || {}) as API78426Req;
    
  
    if ( isMount ) {
      setIsAPI78426Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API78426Res>(`${basePath}/yoaichat-admin/app/copy`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI78426(res || {} as API78426Res);
        setIsAPI78426Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI78426Loading(false);
      }
      return false as unknown as API78426Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI78426Loading,
    dataAPI78426,
    fetchAPI78426Data,
    requestUrl,
  }
}

